import { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { SVG_MUI } from "@ryde/assets";
import { DATA_E2E_KEY, IRideDto, IStyledAttributes } from "@ryde/shared";
import { rydeColors } from "@ryde/theme";

import { FramerTooltip } from "../tooltips";

const RideMlPathIndicatorWrapper = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "ride-ml-path-indicator-wrapper",
})`
  font-family: inherit;
  background: ${rydeColors.orange};
  border-radius: 3px;
  width: 64px;
  height: 24px;
  font-size: 13px;
  font-weight: 400;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  color: ${rydeColors.white};
  text-align: center;
`;

interface IRideMlPathIndicator extends Partial<IRideDto> {
  shouldHideIcon?: boolean;
  shouldTruncateText?: boolean;
}

export const RideMlPathIndicator: FC<IRideMlPathIndicator> = ({ metadata }) => {
  const { t } = useTranslation();

  const isMlPathIndicatorEnabled = useMemo(() => {
    const { customStationRouteId, excludedStationRouteIds = [] } =
      metadata || {};
    if (!customStationRouteId || !excludedStationRouteIds?.length) {
      return Boolean(customStationRouteId);
    }
    const excludedStationRouteIdsSet = new Set(excludedStationRouteIds);
    return !excludedStationRouteIdsSet.has(customStationRouteId);
  }, [metadata]);

  return (
    isMlPathIndicatorEnabled && (
      <FramerTooltip content={t("ride.gridLabel.mlPathIndictor")}>
        <RideMlPathIndicatorWrapper>
          <SVG_MUI.WhiteAsteriskLock3SVG data-e2e="svg-pickup" />
          <span>{t("general.path")}</span>
        </RideMlPathIndicatorWrapper>
      </FramerTooltip>
    )
  );
};
